import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DateFilter } from "src/app/shared/models/date-filte.interface";

@Component({
  selector: "app-display-availabilities",
  templateUrl: "./display-availabilities.component.html",
})
export class DisplayAvailabilitiesComponent implements OnInit {
  @Input() companyName: string;
  @Input() dates: DateFilter[];
  @Output() closeTheModal: EventEmitter<boolean> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeTheModal.emit(true)
  }
}
